'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { LOGIN_TYPE, UnauthQueryOptions } from '@/api';
import { ResponsiveDialog } from '@/components/organism/ResponsiveDialog';
import { SUB_DOMAIN } from '@/constants';
import { useCheckWelloApp } from '@/hooks/useCheckWelloApp';
import { KB_PAY_CUSTOM_SEARCH_PARAMS } from '@/modules/kb-pay';
import { useDeviceInfoStore } from '@/stores/DeviceStore';
import { SocialLoginButton } from './SocialLoginButton';
interface SocialLoginSectionProps {
  isDesktop: boolean;
}
export const SocialLoginSection = t0 => {
  const $ = _c(25);
  const {
    isDesktop
  } = t0;
  const searchParams = useSearchParams();
  let kbId;
  let t1;
  let t2;
  if ($[0] !== searchParams) {
    kbId = searchParams.get(KB_PAY_CUSTOM_SEARCH_PARAMS.KB_ID);
    t2 = useQuery;
    t1 = UnauthQueryOptions["get:/wello/v2/allows/member-oauth/kb-member-login-type"]({
      query: {
        externalMemberId: kbId
      }
    });
    $[0] = searchParams;
    $[1] = kbId;
    $[2] = t1;
    $[3] = t2;
  } else {
    kbId = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const t3 = !!kbId;
  let t4;
  if ($[4] !== t1 || $[5] !== t3) {
    t4 = {
      ...t1,
      enabled: t3,
      select: _temp
    };
    $[4] = t1;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: kbLoginTypeList,
    isPending
  } = t2(t4);
  const isFirstLoginKbUser = !kbLoginTypeList?.length;
  const isCheckingKbUser = isPending && !!kbId;
  const {
    isChecking,
    isWelloApp
  } = useCheckWelloApp();
  const [osType, isKb] = useDeviceInfoStore(useShallow(_temp2));
  const isAndroid = osType === "android";
  const [isOpen, setIsOpen] = useState(false);
  const isLoading = isCheckingKbUser || isChecking || osType === undefined;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      signup_type: "\uC6F0\uB85C",
      step: 1
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const commonEventData = t5;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      method: "\uCE74\uCE74\uC624",
      ...commonEventData
    };
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const kakaoEventData = t6;
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      method: "\uC560\uD50C",
      ...commonEventData
    };
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const appleEventData = t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      method: "\uB124\uC774\uBC84",
      ...commonEventData
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  const naverEventData = t8;
  let t9;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      method: "\uAD6C\uAE00",
      ...commonEventData
    };
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const googleEventData = t9;
  let t10;
  if ($[12] !== isLoading) {
    t10 = cn("mx-auto w-full max-w-[335px] py-16 flex-center", {
      invisible: isLoading
    });
    $[12] = isLoading;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== isAndroid || $[15] !== isDesktop || $[16] !== isFirstLoginKbUser || $[17] !== isKb || $[18] !== isOpen || $[19] !== isWelloApp || $[20] !== kbLoginTypeList) {
    t11 = isKb ? <>{isFirstLoginKbUser ? <div className="flex w-full flex-col gap-8"><SocialLoginButton type="kakao" eventData={kakaoEventData} /><button type="button" onClick={() => setIsOpen(true)} className="h-48 gap-6 rounded-small border border-Gray-300 bg-inherit font-700 text-Gray-700 typo-body3 focus:ring-Gray-300/50 active:scale-[0.98] disabled:border-Gray-400 disabled:bg-Gray-white disabled:text-Gray-400">다른 방법으로 로그인</button></div> : <div className="flex w-full flex-col gap-20">{kbLoginTypeList.includes(LOGIN_TYPE.KAKAO) ? <SocialLoginButton type="kakao" eventData={kakaoEventData} /> : null}{kbLoginTypeList.includes(LOGIN_TYPE.NAVER) ? <SocialLoginButton type="naver" eventData={naverEventData} /> : null}{kbLoginTypeList.includes(LOGIN_TYPE.GOOGLE) ? <SocialLoginButton type="google" eventData={googleEventData} /> : null}{kbLoginTypeList.includes(LOGIN_TYPE.APPLE) ? <SocialLoginButton type="apple" eventData={appleEventData} /> : null}</div>}<ResponsiveDialog opened={isOpen} onClose={() => setIsOpen(false)} drawerType="bottom"><div className="mb-12 flex flex-col gap-8"><p className="py-8 text-center font-700 typo-body1">로그인 방법을 선택하세요</p><SocialLoginButton type="naver" eventData={naverEventData} /><SocialLoginButton type="google" eventData={googleEventData} />{isAndroid && isWelloApp ? null : <SocialLoginButton type="apple" eventData={appleEventData} />}</div></ResponsiveDialog></> : isDesktop ? <div className="flex w-full flex-col gap-8"><SocialLoginButton type="kakao" eventData={kakaoEventData} /><SocialLoginButton type="naver" eventData={naverEventData} /><SocialLoginButton type="google" eventData={googleEventData} />{!(isAndroid && isWelloApp) && <SocialLoginButton type="apple" eventData={appleEventData} />}</div> : <div className="flex w-full flex-col gap-20"><div className="flex w-full flex-col gap-12"><SocialLoginButton type="kakao" eventData={kakaoEventData} /><div className="flex items-center gap-12"><div className="flex-1 border-t border-Gray-200" /><span className="text-Gray-500 typo-caption1">또는</span><div className="flex-1 border-t border-Gray-200" /></div></div><div className="flex justify-center gap-12"><SocialLoginButton type="naver" size="small" eventData={naverEventData} /><SocialLoginButton type="google" size="small" eventData={googleEventData} />{!(isAndroid && isWelloApp) && <SocialLoginButton type="apple" size="small" eventData={appleEventData} />}</div></div>;
    $[14] = isAndroid;
    $[15] = isDesktop;
    $[16] = isFirstLoginKbUser;
    $[17] = isKb;
    $[18] = isOpen;
    $[19] = isWelloApp;
    $[20] = kbLoginTypeList;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <section className={t10}>{t11}</section>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};
function _temp(data) {
  return data.context?.loginTypeList;
}
function _temp2(state) {
  return [state.osType, state.subDomain === SUB_DOMAIN.KB_PAY];
}